var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvascontainer",attrs:{"id":"canvas-container-animation-winterbonusjagd-winter-bg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }